import { PricingHeader } from '@aibees/shared/features/price-and-plan/components/pricing-header';
import { Box } from '@mui/material';
import { ClientsComments } from './components/clients-comments';
import { CollapsedTable } from './components/collapsed-table';
import { COMPARE_PLANS_SCROLL_ID } from './components/collapsed-table/config';
import { CreditUsageOverview } from './components/credit-usage-overview';
import { CurrentPlanBanner } from './components/current-plan-banner';
import { Faq } from './components/faq';
import * as Styled from './styles';

export function PriceAndPlan() {
  return (
    <Styled.Wrapper>
      <PricingHeader />
      <CreditUsageOverview />
      <CurrentPlanBanner />
      <Box id={COMPARE_PLANS_SCROLL_ID}>
        <CollapsedTable />
      </Box>
      <ClientsComments />
      <Faq />
    </Styled.Wrapper>
  );
}
